<template>
  <div class="bar">
    <headBar :title="$ml.get(`Fertilizers`)"/>
    <list/>
  </div>
</template>

<script>
import HeadBar from '@/components/fertilizers/bar/Head'
import List from '@/components/fertilizers/bar/list/List'

export default {
  components: {
    HeadBar,
    List
  }
}
</script>

<style lang="scss" scoped>
  .bar {
    width: 320px;
    min-width: 320px;
    height: -moz-fit-content;
    height: -webkit-fit-content;
    height: fit-content;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
</style>
